import clsx from "clsx";

type SectionBoxProps = {
  title?: React.ReactNode;
  description?: React.ReactNode; // 👈 tambahan
  titleAlign?: "left" | "center" | "right";
  titleClassName?: string;
  descriptionClassName?: string; // 👈 biar bisa custom styling
  children?: React.ReactNode;
  className?: string;
  classNameSub?: string;
  actions?: React.ReactNode;
  background?: string;
};

export default function SectionBox({
  title,
  description,
  titleAlign = "left",
  titleClassName,
  descriptionClassName,
  children,
  className,
  classNameSub,
  actions,
  background = "linear-gradient(175deg, #2c5a7f 0%, #a7bfd3 30%, #ffffff 70%, #ffffff 100%)",
}: SectionBoxProps) {
  return (
    <div
      className={clsx(
        "rounded-xl sm:p-6 md:p-8 lg:p-8 p-4 shadow-md relative ",
        className
      )}
      style={{
        background,
      }}
    >
      <div
      className={clsx(
        "flex justify-between items-start mb-8 container-banner! px-0 sm:!px-0  mx-auto",
        classNameSub
      )}>
        <div
          className={clsx(
            {
              "text-left": titleAlign === "left",
              "text-center mx-auto": titleAlign === "center",
              "text-right ml-auto": titleAlign === "right",
            },
            "max-w-md"
          )}
        >
          <h2
            className={clsx(
              "text-2xl text-gray-800",
              titleClassName
            )}
          >
            {title}
          </h2>
          {description && (
            <p
              className={clsx(
                "mt-2 text-gray-600 text-base",
                descriptionClassName
              )}
            >
              {description}
            </p>
          )}
        </div>
        {actions && <div className="flex gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}
